import type { FC } from 'react';
import React from 'react';

import type { TriggerProps } from '@atlaskit/popup';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

import type { QuickSummaryButtonStyles } from './QuickSummaryButton.tsx';
import { QuickSummaryButton } from './QuickSummaryButton.tsx';
import { useSpotlightEligibilityCheck } from './hooks/useSpotlightEligibilityCheck.tsx';

type QuickSummaryTriggerProps = {
	isOpen: boolean;
	setIsOpen: (bool: boolean) => void;
	triggerProps: TriggerProps;
	contentId: string;
	source: string;
	buttonStyles?: QuickSummaryButtonStyles;
	onOpen?: () => void; // custom onOpen callback for Advanced Search
	onClose?: () => void; // custom onClose callback for Advanced Search
	popularFeedTimeGranularity?: string;
	followingFeedSortby?: string;
};

export const QuickSummaryTrigger: FC<QuickSummaryTriggerProps> = ({
	isOpen,
	setIsOpen,
	triggerProps,
	contentId,
	source,
	buttonStyles,
	onOpen,
	onClose,
	popularFeedTimeGranularity,
	followingFeedSortby,
}) => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	const { isCurrentUserContributor } = useSpotlightEligibilityCheck(contentId, source);

	return (
		<div data-vc="quick-summary-popup" {...ssrPlaceholderIdProp}>
			<QuickSummaryButton
				contentId={contentId}
				triggerProps={triggerProps}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				source={source}
				buttonStyles={buttonStyles}
				onOpen={onOpen}
				onClose={onClose}
				isCurrentUserContributor={isCurrentUserContributor}
				popularFeedTimeGranularity={popularFeedTimeGranularity}
				followingFeedSortby={followingFeedSortby}
			/>
		</div>
	);
};
